export default __webpack_public_path__ + "static/media/criminal1.95877373.jpg";